import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/y2k/banner.jpg'
import navColor from '../../assets/y2k/nav/color.jpg'
import navBg from '../../assets/y2k/nav/nav_bg.png'

import far1 from '../../assets/y2k/nav/far1.png'
import far1_active from '../../assets/y2k/nav/far1_active.png'
import far2 from '../../assets/y2k/nav/far2.png'
import far2_active from '../../assets/y2k/nav/far2_active.png'
import far3 from '../../assets/y2k/nav/far3.png'
import far3_active from '../../assets/y2k/nav/far3_active.png'
import son1 from '../../assets/y2k/nav/son1.png'
import son1_active from '../../assets/y2k/nav/son1_active.png'
import son2 from '../../assets/y2k/nav/son2.png'
import son2_active from '../../assets/y2k/nav/son2_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(115),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(115),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(31)} ${calcRemFn(99)} 0 ${calcRemFn(50)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(65),
    height: calcRemFn(13.5)
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(10)} ${calcRemFn(122)} 0 ${calcRemFn(99)}`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(51),
    height: calcRemFn(34)
  }
}

const navData = {
  // y2kSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ]
  }
}
// 单人 97184
// 闺蜜 97185
const pictureList = [
  {
    key: '1',
    picNum: 2,
    top: 1,
    bottom: 1,
    pid: 97184
  },
  {
    key: '2',
    picNum: 2,
    top: 1,
    bottom: 2,
    pid: 97185
  },
  {
    key: '3',
    picNum: 2,
    top: 2,
    bottom: 1,
    pid: 97184
  },
  {
    key: '4',
    picNum: 2,
    top: 2,
    bottom: 2,
    pid: 97185
  },
  {
    key: '5',
    picNum: 3,
    top: 3,
    bottom: 1,
    pid: 97184
  },
  {
    key: '6',
    picNum: 3,
    top: 3,
    bottom: 2,
    pid: 97185
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, top, bottom } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/y2k/ctn/${key}_${index + 1}.jpg`))
    })
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${top}_i${bottom}`,
      farName: `top${top}`,
      sonName: `_i${bottom}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top2_i1: -14,
  top3_i1: 36,
}

export default {
  title: 'FANTASY限定',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
